import { useState, useEffect, useContext } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { apiUrls } from "../../utils/apiUrls";
import { getData } from "../../utils/reusables";
import { SelectPicker } from "rsuite";
import UploaderWithTable from "../../Components/generic/fileUpload/uploaderWithTable.component";
import { NotificationContext } from "../../core/context/notificationContextProvider";
import {
  notificationContextTypes,
  typeApiResponse,
  typeCountryDto,
} from "../../utils/typeDefs";
import styles from "./contentUpload.module.scss";
import { AxiosResponse } from "axios";
import { Link } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";

type contentUploadProps = {
  title: string;
  windowHeight: number;
  windowWidth: number;
};

export type uploadResponseProps = {
  status: string;
  type: string;
  message: string;
};

const ContentUpload = ({
  title,
  windowHeight,
  windowWidth,
}: contentUploadProps) => {
  const [countryList, setCountryList] = useState<typeCountryDto[] | []>([]);
  const [countryId, setCountryId] = useState<number | null>(null);
  const [countryName, setCountryName] = useState<string | null>(null);

  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;

  useEffect(() => {
    getData(apiUrls.country.base).then(
      (result: AxiosResponse<{ data: typeCountryDto[] } & typeApiResponse>) =>
        setCountryList(result.data.data)
    );
  }, []);

  useEffect(() => {
    if (countryId !== 0 && countryList.length > 0) {
      let newCountry: string | null = null;

      for (let i = 0; i < countryList.length; i++) {
        if (countryId === countryList[i].id) {
          newCountry = countryList[i].name;
          setCountryName(newCountry);
          break;
        }
      }
    }
  }, [countryId, countryList]);

  const navigate = useNavigate();

  return (
    <section>
      <h1 className="page-title pb-3">
        {title} {countryId && <span className="text-info">{countryName}</span>}
      </h1>
      <div className={`pb-4 ${styles.selectorWrapper}`}>
        <SelectPicker
          onOpen={() => {
            const selectMenu = document.querySelector(".rs-picker-select-menu");

            if (selectMenu && !selectMenu.classList.contains("custom-picker")) {
              selectMenu.classList.add("custom-picker");
            }
          }}
          onClean={() => {
            navigate(AppRoutesUI.ContentUpload.Path());
          }}
          data={countryList}
          labelKey="name"
          valueKey="id"
          onChange={(value: number | null) => {
            setCountryId(value);
          }}
          sort={() => (a, b) => a.name < b.name ? -1 : 1}
          placeholder="Select Country"
          renderMenuItem={(label, item) => {
            return (
              <Link className="country-nav" to={`/content-upload/${item.id}`}>
                {label}
              </Link>
            );
          }}
        />
      </div>

      <Routes>
        <Route
          path={"/"}
          element={
            <UploaderWithTable
              countryId={countryId}
              windowHeight={windowHeight}
              windowWidth={windowWidth}
              triggerNotification={triggerNotification}
            />
          }
        />

        <Route
          path={":countryId"}
          element={
            <UploaderWithTable
              countryId={countryId}
              windowHeight={windowHeight}
              windowWidth={windowWidth}
              triggerNotification={triggerNotification}
            />
          }
        />
      </Routes>
    </section>
  );
};

export default ContentUpload;
